import { useCallback, useState } from 'react';
import { AdvancedMarker, InfoWindow, Pin, useAdvancedMarkerRef } from '@vis.gl/react-google-maps';
import { GruenlandHeaderLogo } from 'components/svgr/GruenlandHeaderLogo';
import { GruenlandJuniorHeaderLogo } from 'components/svgr/GruenlandJuniorHeaderLogo';
import { TYPOGRAPHY_STORE_CARD_TITLE } from 'lib/typography';
import type { Store } from './types';

type Props = {
  store: Store;
};

const StoreMarker: React.FC<Props> = ({ store }) => {
  const [markerRef, marker] = useAdvancedMarkerRef();
  const [shown, setShown] = useState(false);
  const handleToggle = useCallback(() => setShown((x) => !x), []);
  const handleClose = useCallback(() => setShown(false), []);
  return (
    <AdvancedMarker ref={markerRef} position={{ lat: store.lat, lng: store.lng }} onClick={handleToggle}>
      <Pin borderColor="#00633A" background="#007343" glyphColor="#fff" />
      {shown && (
        <InfoWindow anchor={marker} onClose={handleClose}>
          <p className={TYPOGRAPHY_STORE_CARD_TITLE}>{store.name}</p>
          <p className="mb-4 mt-2">
            {store.city}
            <br />
            {store.addr}
          </p>
          <div className="flex gap-4">
            {store.has_grlnd && <GruenlandHeaderLogo height={24} />}
            {store.has_jr && <GruenlandJuniorHeaderLogo height={24} />}
          </div>
        </InfoWindow>
      )}
    </AdvancedMarker>
  );
};

export default StoreMarker;
